import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared/state';

interface OrganizationDashboardNavIds {
  organizationNavBarButtonId: string;
  logoId: string;
  organizationNavPeriodPickerId: string;
}

export const useOrganizationDashboardNavIds = (): OrganizationDashboardNavIds => ({
  organizationNavBarButtonId: useAnalyticId(AnalyticIdentifier.RTC_COMPANY_NAV_BAR_BUTTON),
  logoId: useAnalyticId(AnalyticIdentifier.COMPANY_DASHBOARD_LOGO),
  organizationNavPeriodPickerId: useAnalyticId(AnalyticIdentifier.RTC_COMPANY_NAV_PERIOD_PICKER),
});
